export default __webpack_public_path__ + "static/media/menu-01-address-book-w.b5806b5e.svg";